import {AppRouteData, BreadcrumbItemProps} from '../../types/AppRoutesPropType';
import React from 'react';
import {contentItemPaths} from './paths';


const contentItemSectionBreadcrumbs = [new BreadcrumbItemProps('Content Assets', contentItemPaths.ContentItemSearch)];

const EditPage = React.lazy(() => import('./ContentItemEditPage'));
const DetailPage = React.lazy(() => import('./ContentItemProfile'));
const SearchPage = React.lazy(() => import('./ContentItemSearch'));

const contentItemRouteConfig = [
  { path: contentItemPaths.ContentItemSearch, element: <SearchPage />, handle: AppRouteData.create('Search', undefined, contentItemSectionBreadcrumbs) } ,
  { path: contentItemPaths.ContentItemProfile, element: <DetailPage />, handle: AppRouteData.create('Details', undefined, contentItemSectionBreadcrumbs) } ,
  { path: contentItemPaths.ContentItemCreate, element: <EditPage />, handle: AppRouteData.create('Create', undefined, contentItemSectionBreadcrumbs) } ,
  { path: contentItemPaths.ContentItemEdit, element: <EditPage />, handle: AppRouteData.create('Edit', undefined, contentItemSectionBreadcrumbs) } ,
];

export default contentItemRouteConfig;